module.exports = {
	"blank": {
		"appImage": "https://firebasestorage.googleapis.com/v0/b/tester-8e38d.appspot.com/o/iPhone.png?alt=media&token=8abeb240-ce82-4389-9578-a00f9f2219d3",
		"appLogo": "https://firebasestorage.googleapis.com/v0/b/tester-8e38d.appspot.com/o/1547909762580.jpg?alt=media&token=6ebe1963-2214-430b-8a08-d4707b406c42",
		"appNavLogo": "https://firebasestorage.googleapis.com/v0/b/tester-8e38d.appspot.com/o/1547909755800.jpg?alt=media&token=88654f56-e182-4347-a168-50752f35fafe",
		"appSplash": "https://firebasestorage.googleapis.com/v0/b/tester-8e38d.appspot.com/o/1547909722339.jpg?alt=media&token=69b5c168-2e2d-4c11-970b-d9f46255cbe0",
		"config": {
			"currency_format": "amount_with_comma_separator",
			"currency_value": "$",
			"date_format": "d-m-Y",
			"date_format_from": "Y-m-d",
			"distance_in": "km",
			"loginRequired": true,
			"showSlides": false,
			"time_format": "H:I",
			"time_format_from": "h:i",
			"userVarification": false
		},
		"design": {
			"category": {
				"textColor": "#ffffff"
			},
			"general": {
				"backgroundColor": "#fefeff",
				"backgroundGradient": [
					{
						"color": "#48486f"
					},
					{
						"color": "#1d243c"
					}
				],
				"backgroundImage": false,
				"buttonBorderColor": "#000000",
				"buttonColor": "#555454",
				"buttonText": "#ffffff",
				"coloring": "advanced",
				"detailsBackgroundGradient": [
					{
						"color": "#fefeff"
					},
					{
						"color": "#FEFEFE"
					}
				],
				"detailsBackgroundImage": false,
				"hideTabIconName": true,
				"isRTL": false,
				"layout": "side",
				"outbound": false,
				"rounded": true
			},
			"navBar": {
				"backgroundColor": "rgba(0,0,0,0.0)",
				"barStyle": "light-content",
				"borderColor": "rgba(0,0,0,0.0)",
				"detailsBackgroundColor": "#ffffff",
				"detailsTintColor": "#000000",
				"statusBarBackgroundColor": "#000000",
				"tintColor": "#ffffff"
			},
			"rows": {
				"arrowColor": "#ffffff",
				"backgroundColor": "#ffffff",
				"desciptionColor": "#555555",
				"imageRowColor": "rgba(0,0,0,0.5)",
				"imageRowFontSize": 18,
				"imageRowFontWeight": "normal",
				"separatorColor": "#ffffff",
				"subtitleColor": "#666666",
				"titleColorOnGrid": "#ffffff",
				"titleColorOnRow": "#444444"
			},
			"sideMenu": {
				"activeBackgroundColor": "#eeeeee",
				"activeTintColor": "#773cc4",
				"backgroundColor": "#ffffff",
				"inactiveBackgroundColor": "rgba(0,0,0,0)",
				"inactiveTintColor": "#111111"
			},
			"specialRows": {
				"arrowColor": "#ffffff",
				"backgroundColor": "#30324c",
				"desciptionColor": "#ffffff",
				"imageRowColor": "rgba(256,256,256,0.5)",
				"imageRowFontSize": 18,
				"imageRowFontWeight": "normal",
				"separatorColor": "#eeeeee",
				"subtitleColor": "red",
				"titleColorOnGrid": "#ffffff",
				"titleColorOnRow": "#ffffff"
			}
		},
		"navigation": {
			"menus": [
				{
					"html": "<img class='img-responsive' src='https://s3.amazonaws.com/tcdn.mobidonia.com/codecanyon/info/Screenshot+at+Mar+20+23-01-48.png' /> <br /><br /> <div class=\"col-md-12\">     <h4>Thanks for using Xcape App Builder</h4>     </div>",
					"icon": "FeInfo",
					"name": "webview",
					"sectionType": "web",
					"url": "https://xcape.in",
					"webSource": "html"
				}
			]
		},
		"name": "Blank"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/builder/apps.json
// module id = 1080
// module chunks = 0